import * as z$1 from "zod/v4";
//#region src/schemas/daemon/service-contract.ts
const DAEMON_SERVICE_CONTRACT_SCHEMA_VERSION = 1;
const daemonServiceLaneSchema = z$1.enum([
	"prod",
	"dev-local",
	"canary"
]);
const daemonServiceDesiredStateSchema = z$1.enum(["stopped", "background"]);
const daemonServiceControllerSchema = z$1.enum([
	"launchd",
	"systemd",
	"windows-service",
	"legacy-detached",
	"unknown"
]);
const daemonServiceContractSchema = z$1.strictObject({
	schema: z$1.literal("openmeld-daemon-service-contract-v1"),
	v: z$1.literal(1),
	lane: daemonServiceLaneSchema,
	daemonVersion: z$1.string().min(1),
	bundleId: z$1.string().min(1),
	desiredState: daemonServiceDesiredStateSchema,
	serviceController: daemonServiceControllerSchema,
	autoStart: z$1.boolean(),
	gatewayUrl: z$1.string().min(1),
	ownerUserId: z$1.string().min(1).optional(),
	profileId: z$1.string().min(1).optional(),
	deviceId: z$1.string().min(1),
	connectedComputerId: z$1.string().min(1).optional(),
	heartbeatMs: z$1.int().positive(),
	generation: z$1.int().positive(),
	updatedAt: z$1.string().min(1)
});
//#endregion
export { DAEMON_SERVICE_CONTRACT_SCHEMA_VERSION, daemonServiceContractSchema, daemonServiceControllerSchema, daemonServiceDesiredStateSchema, daemonServiceLaneSchema };

//# sourceMappingURL=service-contract.js.map